// Screen with Size less than 1440
export const isSmallScreen = () => {
  return false; // screen.width < 1440;
};
